/**
 * Maps a WorkflowRun status string to a BadgeVariant + display label.
 * Pure function — no JSX. Import into list + detail cells.
 */
import type { BadgeVariant } from '../../../components/ui/index.js';
import { sentenceCase } from '../../../components/ui/FilterSelect.js';

export type RunStatusLabel = 'Succeeded' | 'Running' | 'Failed' | 'Cancelled' | 'Pending' | 'Unknown';

interface RunStatusMeta {
  variant: BadgeVariant;
  label: RunStatusLabel | string;
}

const STATUS_MAP: Record<string, RunStatusMeta> = {
  completed: { variant: 'success', label: 'Succeeded' },
  succeeded: { variant: 'success', label: 'Succeeded' },
  running: { variant: 'accent', label: 'Running' },
  failed: { variant: 'danger', label: 'Failed' },
  cancelled: { variant: 'neutral', label: 'Cancelled' },
  canceled: { variant: 'neutral', label: 'Cancelled' },
  pending: { variant: 'neutral', label: 'Pending' },
  queued: { variant: 'neutral', label: 'Pending' },
};

export function runStatusVariant(status: string | undefined | null): RunStatusMeta {
  if (!status) return { variant: 'neutral', label: 'Unknown' };
  return STATUS_MAP[status.toLowerCase()] ?? { variant: 'neutral', label: sentenceCase(status) };
}
